import { render, staticRenderFns } from "./MyInquiriesPage.vue?vue&type=template&id=7e11b4fc&scoped=true"
import script from "./MyInquiriesPage.vue?vue&type=script&lang=js"
export * from "./MyInquiriesPage.vue?vue&type=script&lang=js"
import style0 from "./MyInquiriesPage.vue?vue&type=style&index=0&id=7e11b4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e11b4fc",
  null
  
)

export default component.exports